import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import type { Fields } from '~/ducks/authentication/data/AuthenticationState';

const useAuthenticationState = (): Fields =>
  useSelector((s: AppState) => s.authentication);

export default useAuthenticationState;
